/*
  Wishlist toggle for the compact Makri Home product card.

  The store has no wishlist backend, so the saved product ids live in
  localStorage on the shopper's own device. Nothing is written until the
  shopper actually presses a heart, and nothing leaves the browser.
*/
(() => {
  if (window.makriWishlistInitialized) return;
  window.makriWishlistInitialized = true;

  const STORAGE_KEY = 'makri:wishlist';
  const SELECTOR = '[data-makri-wishlist]';

  function read() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return new Set(Array.isArray(stored) ? stored.map(String) : []);
    } catch (error) {
      return new Set();
    }
  }

  function write(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
    } catch (error) {
      // Storage can be unavailable (private mode, blocked site data).
      // The toggle then only lasts for the current page view.
    }
  }

  function paint(button, saved) {
    const isSaved = saved.has(button.dataset.productId);
    button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');

    const label = isSaved ? button.dataset.labelRemove : button.dataset.labelAdd;
    if (label) button.setAttribute('aria-label', label);
  }

  function sync(root) {
    const saved = read();
    (root || document).querySelectorAll(SELECTOR).forEach((button) => paint(button, saved));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(SELECTOR);
    if (!button || !button.dataset.productId) return;

    event.preventDefault();

    const saved = read();
    if (saved.has(button.dataset.productId)) {
      saved.delete(button.dataset.productId);
    } else {
      saved.add(button.dataset.productId);
    }

    write(saved);
    sync();
  });

  document.addEventListener('shopify:section:load', (event) => sync(event.target));

  sync();
})();
